import axios from 'axios';
import * as endpoints from './endpoints';
import store from '../store';
import * as actions from '../actions/logs-action';
import * as blockUtils from '../utils/BlockUtils';

export function getLogsForKeyCreation(data) {
  axios.get(endpoints.LOGS_KEY_CREATION, endpoints.headers(data))
      .then((response) => {
        const logs = response.data.content;
        const totalPages = response.data.totalPages;
        const totalElements = response.data.totalElements;

        store.dispatch(actions.getLogsKeyCreationSuccess(logs, totalPages, totalElements));
        blockUtils.unblockUI();
      })
      .catch((error) => {
        endpoints.handleUnauthorizedError(error, () => {
          store.dispatch(actions.getLogsKeyCreationError(error));
          blockUtils.unblockUI();
        });
      },
      );
}
